require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-neusiedl-bruckneudorf.json") })
        }
      }, "path---betreuungseinrichtungen-neusiedl-bruckneudorf");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-neusiedl-bruckneudorf!./.cache/json/betreuungseinrichtungen-neusiedl-bruckneudorf.json
// module id = 945
// module chunks = 231608221292675